import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  loading: '/placeholder.png',
  error: '/placeholder.png',
  observer: true
})
